import { Box, Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import { FormTextInputDisplay } from '../../form-field-components/new-and-edit/form-text-input'
import { ISrsNarrativeField } from '../../../../shared/services/srs-report/srs-report.model'

/**
 * One narrative pillar of the wizard (governance, strategy or risk management). Everything shown
 * here comes from the structure endpoint: headings, guidance and paragraph references are the
 * backend's, so the standard's shape lives in exactly one place. Guidance is an explainer only and
 * is never submitted or printed; an empty narrative renders as "Not disclosed." in the document.
 */
export const SrsStepNarratives: FunctionComponent<{
  sectionLabel: string
  intro: string
  fields: ISrsNarrativeField[]
  values: Record<string, string>
  onChange: (field: string, value: string) => void
}> = ({ sectionLabel, intro, fields, values, onChange }) => {
  return (
    <>
      <Typography variant='h6' sx={{ mb: 1 }}>{sectionLabel}</Typography>
      <Typography variant='body2' sx={{ color: 'text.secondary', mb: 3 }}>
        {intro} Sections left empty appear as &ldquo;Not disclosed.&rdquo; in the published document.
      </Typography>

      {fields.map((field) => (
        <Box sx={{ mb: 3 }} key={field.field}>
          <FormTextInputDisplay
            isEditPage={false}
            disabled={false}
            title={field.heading}
            name={field.field}
            value={values[field.field] || ''}
            onChange={(event: any) => onChange(field.field, event.target.value)}
            multiline
            rows={5}
            forceOutlined
            regularFieldLabel
            isTopRow
            isBottomRow
            helperText={field.guidance}
          />
          <Typography variant='caption' sx={{ display: 'block', color: 'text.secondary', mt: 0.5 }}>
            {field.reference}
          </Typography>
        </Box>
      ))}
    </>
  )
}
